/* KlimaMont — Petrol Tech theme interactions.
   Dependency-free. All behavior is progressive-enhancement:
   the store works without JS (links/forms submit normally). */
(function () {
  'use strict';

  /* ---- mobile nav drawer ---- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-drawer-open]');
      var close = e.target.closest('[data-drawer-close]');
      if (open) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      if (close || e.target === drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  }

  /* ---- quantity steppers ---- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      if (!wrap) return;
      var input = wrap.querySelector('input');
      var val = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      val += (btn.getAttribute('data-qty') === 'inc' ? 1 : -1);
      input.value = Math.max(min, Math.min(max, val));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---- live cart count via Shopify AJAX API ---- */
  function refreshCartCount() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---- add-to-cart from product cards (no page reload) ---- */
  function initAjaxAdd() {
    if (!window.fetch) return;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"][data-ajax-add]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCartCount(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---- PDP image gallery: swipe (native scroll-snap) + thumbnail navigation ---- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      if (!track) return;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));

      function setActive(i) {
        thumbs.forEach(function (t) {
          var on = parseInt(t.dataset.galleryThumb, 10) === i;
          t.classList.toggle('is-active', on);
          if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.dataset.galleryThumb, 10) || 0;
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        });
      });

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (!track.clientWidth) return;
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        });
      });

      // keyboard arrows when the track is focused
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var cur = Math.round(track.scrollLeft / track.clientWidth);
        var next = Math.max(0, Math.min(thumbs.length ? thumbs.length - 1 : cur, cur + (e.key === 'ArrowRight' ? 1 : -1)));
        track.scrollTo({ left: track.clientWidth * next, behavior: 'smooth' });
        setActive(next);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initQty();
    initAjaxAdd();
    initGallery();
    refreshCartCount();
  });
})();
